import { store } from '../../index';
var ClientHelper = /** @class */ (function () {
    function ClientHelper() {
    }
    ClientHelper.abortPreviousRequest = function (abortController) {
        if (abortController) {
            abortController.abort();
        }
    };
    ClientHelper.dispatchNewRequestAction = function (storageKeyParam, actionType, abortControllerParam) {
        var requestAction = {
            storageKey: storageKeyParam,
            type: actionType,
            abortController: abortControllerParam,
        };
        store.dispatch(requestAction);
    };
    return ClientHelper;
}());
export default ClientHelper;
